// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"c68a8658","739":"50b81afc"}[chunkId] + ".chunk.js";
};